import { GeneratePublicToken } from "../utils/GeneratePublicToken";
import axios from "axios";
import Cookies from "js-cookie";

const token = () => Cookies.get("accessTokenOfficeOlin");

export const getApprovalPbfList = async (body) => {
    try {
        const config = {
            headers: { Authorization: `Bearer ${token()}` },
            url: `${process.env.REACT_APP_API_PBF}pbf/transaction/approvals`,
            method: "POST",
            data: body
        };
        const res = await axios(config);
        return res.data.detail;
    } catch (err) {
        throw err;
    }
}

export const setApprovalPbf = async (body) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token()}`,
            },
            method: "POST",
            url: `${process.env.REACT_APP_API_PBF}pbf/transaction/approval/action`,
            data: body,
        };
        const res = await axios(config);
        return res.data;
    } catch (err) {
        throw err.response.data;
    }
};


export const getApprovalPbfDetail = async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${token()}`,
            },
            method: "POST",
            url: `${process.env.REACT_APP_API_PBF}pbf/transaction/approval?invoice_uid=${id}`,
        };
        const res = await axios(config);
        return res.data;
    } catch (err) {
        throw err.response.data;
    }
};

export const getDetailSfa = async (invNum) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      method: "GET",
      url: `${process.env.REACT_APP_API_PURCHASE}approval/order?order_number=${invNum}`,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};

export const getDetailApprovalPbf = async (uid) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token()}`,
      },
      method: "GET",
      url: `${process.env.REACT_APP_API_PBF}pbf/transaction/approval?invoice_uid=${uid}`,
    };
    const res = await axios(config);
    return res.data.detail;
  } catch (err) {
    throw err.response.data;
  }
};
